/**
 * Session-scoped plan catalog: one fetch per browser session, shared by marketing
 * and legal pages that must show the same numbers as `/api/subscription/plans`.
 */

import { listSubscriptionPlans, type SubscriptionPlan } from './subscriptionPlans.service'

let sessionLoad: Promise<SubscriptionPlan[]> | null = null

/**
 * Resolves to the same promise for all callers until the first request settles;
 * subsequent navigations reuse the cached result for the lifetime of the page session.
 */
export function loadPlanCatalog(): Promise<SubscriptionPlan[]> {
  if (!sessionLoad) {
    sessionLoad = listSubscriptionPlans().catch((err) => {
      sessionLoad = null
      throw err
    })
  }
  return sessionLoad
}

/** Test-only: reset the session singleton. */
export function resetPlanCatalogSessionCache(): void {
  sessionLoad = null
}
